import React from 'react';

const Footer = () => {
    return (
        <div className="footer-page">
            <div className="col-md-11 col-12 p-0 d-flex justify-content-between m-auto">
                <div className="dashboard-image">
                    <img src="https://res.cloudinary.com/teewhy/image/upload/v1562151644/WificomngLogo.png" alt="logo"
                         width="50%"/>
                </div>

                <div>
                    <p><b>Connect with us</b></p>
                    <div className="social-icons d-flex mt-2">
                        <div className="mr-auto links">
                            <i className="fa fa-twitter"></i>
                        </div>

                        <div className="mr-auto links">
                            <i className="fa fa-facebook"></i>
                        </div>

                        <div className="mr-auto links">
                            <i className="fa fa-instagram"></i>
                        </div>

                        <div className="mr-auto links">
                            <i className="fa fa-linkedin-square"></i>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Footer;